import {types} from '../../types';

const initialState = {
    list: [],
    edit: {}
}

export function pinsaleReducer(state = initialState, action) {
    switch (action.type) {
        case types.pinsale.SET_LIST:
            return { ...state, list: action.payload};
        case types.pinsale.SET_EDIT:
            return { ...state, edit: action.payload};
        default:
            return state
    }
}